"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_secrets_manager_1 = require("@aws-sdk/client-secrets-manager");
class SecretsManager {
    constructor(paramsOverride) {
        this.secretsManagerClient = new client_secrets_manager_1.SecretsManagerClient(paramsOverride || {});
    }
    async getSecret(secretName) {
        const command = new client_secrets_manager_1.GetSecretValueCommand({ SecretId: secretName });
        return this.secretsManagerClient.send(command);
    }
    async getSecretKey(secretName, valueKey) {
        const response = await this.getSecret(secretName);
        if (response.SecretString) {
            const secretData = JSON.parse(response.SecretString);
            return secretData[valueKey];
        }
        throw new Error('No value found in secrets manager');
    }
}
exports.default = SecretsManager;
